import {mapRatingScoreToSentiment} from '@travel-frontend/ui-components';

import {REVIEW_SCORE_MAX, REVIEW_SCORE_MAX_BACKEND} from '@/consts';

export const formatScore = (rawScore: number) => {
  const scoreScaled = rawScore / (REVIEW_SCORE_MAX_BACKEND / REVIEW_SCORE_MAX);
  const score = Math.ceil(scoreScaled * 10) / 10;
  const scoreFormatted = score.toFixed(1);
  const scoreMax = REVIEW_SCORE_MAX.toFixed(1);
  const sentiment = mapRatingScoreToSentiment(score);

  return {
    score,
    scoreFormatted,
    scoreMax,
    sentiment,
  };
};
